import { h, Component } from 'preact';
import { withLocationModel } from '@cube/location-model';
import debounce from '@os/debounce';
import { trackEvent, INPUT_KEYS, DIMENSION, EVENT  } from '@cube/track';

import { SEARCHING_DELAY, MAX_FAVORITES, MAX_RECENTLY_SEARCHED } from '../../constants';

import LocationPopover from '../location-popover';
import LocationTextInput from '../location-textinput';

export class Location extends Component {
	state = {
		searchTerm: ''
	};

	handleSetCurrent = (location) => {
		const { isCurrent, isRecent, onChangeRecent, onChangeCurrent, recent } = this.props;

		if (isCurrent && isCurrent(location)) { return; }

		if (isRecent && !isRecent(location)) {
			onChangeRecent && onChangeRecent([location].concat(recent));
		}

		this.setState({ searchTerm: '' });

		onChangeCurrent && onChangeCurrent(location);
	};

	handleAddFavorite = (location) => {
		let { favorites, isFavorite, onChangeFavorites } = this.props;

		// TODO: Sorting?
		favorites = [
			...(
				isFavorite && isFavorite(location)
					?	favorites.filter((favLoc) => favLoc.id !== location.id)
					: favorites
			),
			location
		];

		this.handleSetCurrent(location);
		onChangeFavorites && onChangeFavorites(favorites);

		trackEvent( this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.componentpath]: 'Location.AddFavorite',
			[DIMENSION.text]: location.name
		});
	};

	handleDismissFavorite = (location) => {
		let { favorites, recent, isRecent, onChangeFavorites, onChangeRecent } = this.props;

		favorites = favorites.filter((favLoc) => favLoc.id !== location.id);

		recent = [location].concat(
			isRecent && isRecent(location)
				? recent.filter((recentLoc) => recentLoc.id !== location.id)
				: recent
		);

		onChangeFavorites && onChangeFavorites(favorites);
		onChangeRecent && onChangeRecent(recent);

		trackEvent( this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.componentpath]: 'Location.DismissFavorite',
			[DIMENSION.text]: location.name
		});
	};

	handleSearchInput = (searchTerm) => {
		this.setState({ searchTerm });
		this.props.onChangeSearchTerm && this.props.onChangeSearchTerm(searchTerm);
	};

	static defaultProps = {
		maxFavorites: MAX_FAVORITES,
		maxRecent: MAX_RECENTLY_SEARCHED
	};

	componentWillMount() {
		const { current, onChange } = this.props;
		if (current) {
			onChange && onChange(current);
		}
	}
	componentWillReceiveProps({ current, onChange }) {
		if (current && (this.props.current && this.props.current.id) !== current.id) {
			onChange && onChange(current);
		}
	}

	render({
		maxFavorites,
		maxRecent,
		primary = {},
		current = {},
		favorites = [],
		recent = [],
		isFavorite,
		searchResults,
		label, fullWidth,
		...props
	}, { searchTerm }) {
		const isFavoritesFull = favorites.length >= maxFavorites;
		const recentWithoutFavorites = recent.filter((recentLoc) => isFavorite && !isFavorite(recentLoc)).slice(0, maxRecent);
		const pending = !current.id;

		const Child = fullWidth ? LocationTextInput : LocationPopover;
		return (
			<Child
				{...props}
				pending={pending}
				isFavoritesFull={isFavoritesFull}
				maxFavorites={maxFavorites}
				maxRecent={maxRecent}
				primary={primary}
				current={current}
				favorites={favorites}
				recent={recentWithoutFavorites}
				searchResults={searchResults}
				label={label}
				searchTerm={searchTerm}
				isFavorite={isFavorite}
				onSearchInput={this.handleSearchInput}
				onSetCurrent={this.handleSetCurrent}
				onAddFavorite={this.handleAddFavorite}
				onDismissFavorite={this.handleDismissFavorite}
			/>
		);
	}
}

function enhance(Child) {
	return withLocationModel(
		(locations) => locations,
		(model, ownProps) => ({
			onChangeCurrent: (location) => {
				model.actions.change.current(location);
				ownProps.onChange && ownProps.onChange(location);
			},
			onChangeFavorites: model.actions.change.favorites,
			onChangeRecent: model.actions.change.recent,
			onChangeSearchTerm: debounce(model.actions.change.searchTerm, SEARCHING_DELAY),
			isPrimary: model.is.primary,
			isCurrent: model.is.current,
			isRecent: model.is.recent,
			isFavorite: model.is.favorites
		})
	)(
		Child
	);
}

export default enhance(Location);
